// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {combineReducers} from 'redux';

import {GenericAction} from 'mattermost-redux/types/actions';

import {ActionTypes, WindowSizes} from 'utils/constants';

function windowSize(state = WindowSizes.DESKTOP_VIEW, action: GenericAction) {
    switch (action.type) {
    case ActionTypes.BROWSER_WINDOW_RESIZED:
        return action.data;
    default:
        return state;
    }
}

export default combineReducers({
    windowSize,
});
